import styled from 'styled-components';

export const NotificationsContainer = styled.div`
    padding-inline: 15px;
`

export const NotificationsCard = styled.ul`
    background-color: ${({theme}) => theme.colors.primary};
    padding: 15px;
    min-height: 80vh;
`

export const NotificationsList = styled.li`
    border: 1px solid ${({theme}) => theme.colors.button.background};
    list-style: none;
    margin-block: 10px;
    padding: 0px 15px;
    cursor: pointer;
`